module.exports = __webpack_public_path__ + "img/bg.66a29567.png";